module.exports = __webpack_public_path__ + "4e3425a001d0720b0b1a6ba27011638a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-left-7.png
// module id = 2581
// module chunks = 0